import { SUB_PAGES } from "../../../../interfaces/RegionalPage";
import { CASTING_PLANT } from "./_casting_plant";
import { FINANCIAL_SERVICES } from "./_financial_services";
import { MOTOR_BUSINESS } from "./_motor_business";

export const AUSTRALIA_NEWZEALAND_SUB_PAGES: SUB_PAGES[] = [
   MOTOR_BUSINESS,
   FINANCIAL_SERVICES,
   CASTING_PLANT
]